import { useAccountant } from "./AccountantContext";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid";
import CircularProgress from "@mui/material/CircularProgress";
import Alert from "@mui/material/Alert";

export default function FilterBar({
    showJobIdFilter = false,
    showRegionSelector = false,
    showInvoiceButton = false,
    showExportButton = false,
    onRefresh,
    onIssueInvoice,
    onExport,
}) {
    const [state, dispatch] = useAccountant();

    const toDateStr = (d) => {
        const dd = new Date(d);
        const year = dd.getFullYear();
        const month = String(dd.getMonth() + 1).padStart(2, '0');
        const day = String(dd.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    return (
        <div>
            <Grid container spacing={2} alignItems="flex-end" sx={{ py: 1, minHeight: 70 }}>
                {showJobIdFilter && (
                    <Grid item>
                        <TextField
                            type="number"
                            variant="standard"
                            placeholder="Filter the Job Id"
                            value={state.searchJobId}
                            disabled={state.isInvoiceInProgress}
                            onChange={(e) => dispatch({ type: 'SET_SEARCH_JOB_ID', payload: e.target.value })}
                            sx={{ minWidth: 150 }}
                        />
                    </Grid>
                )}
                <Grid item>
                    <TextField
                        variant="standard"
                        placeholder="Filter the address"
                        value={state.searchAddress}
                        disabled={state.isInvoiceInProgress}
                        onChange={(e) => dispatch({ type: 'SET_SEARCH_ADDRESS', payload: e.target.value })}
                        sx={{ minWidth: 180 }}
                    />
                </Grid>
                <Grid item>
                    <TextField
                        variant="standard"
                        placeholder="Filter the agent"
                        value={state.searchAgent}
                        disabled={state.isInvoiceInProgress}
                        onChange={(e) => dispatch({ type: 'SET_SEARCH_AGENT', payload: e.target.value })}
                        sx={{ minWidth: 150 }}
                    />
                </Grid>
                {showRegionSelector && state.allRegions.length > 0 && (
                    <Grid item>
                        <FormControl variant="standard" sx={{ minWidth: 150 }}>
                            <Select
                                value={state.filterRegion || ''}
                                disabled={state.isInvoiceInProgress}
                                onChange={(e) => dispatch({ type: 'SET_REGION', payload: e.target.value })}
                            >
                                {state.allRegions.map((region) => (
                                    <MenuItem key={region} value={region}>{region}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                )}
                {(showInvoiceButton || showExportButton || showRegionSelector) && (
                    <>
                        <Grid item>
                            <TextField
                                type="date"
                                variant="standard"
                                label="Choose From Date"
                                value={toDateStr(state.filterStartDate)}
                                disabled={state.isInvoiceInProgress}
                                onChange={(e) => dispatch({ type: 'SET_START_DATE', payload: new Date(e.target.value + 'T00:00:00') })}
                                InputLabelProps={{ shrink: true }}
                                sx={{ minWidth: 150 }}
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                type="date"
                                variant="standard"
                                label="Choose To Date"
                                value={toDateStr(state.filterEndDate)}
                                disabled={state.isInvoiceInProgress}
                                onChange={(e) => dispatch({ type: 'SET_END_DATE', payload: new Date(e.target.value + 'T00:00:00') })}
                                InputLabelProps={{ shrink: true }}
                                sx={{ minWidth: 150 }}
                            />
                        </Grid>
                    </>
                )}
                {showExportButton && (
                    <Grid item>
                        <Button variant="contained" color="primary" onClick={onExport} disabled={state.loading} sx={{ textTransform: 'none' }}>
                            Export
                        </Button>
                    </Grid>
                )}
                {showInvoiceButton && (
                    <>
                        <Grid item>
                            <FormControl variant="standard" sx={{ minWidth: 160 }}>
                                <Select
                                    value={state.invoiceGroupType}
                                    disabled={state.isInvoiceInProgress}
                                    onChange={(e) => dispatch({ type: 'SET_GROUP_TYPE', payload: e.target.value })}
                                >
                                    <MenuItem value="PER_JOB">Invoice Per Job</MenuItem>
                                    <MenuItem value="PER_PROPERTY">Invoice Per Property</MenuItem>
                                    <MenuItem value="PER_AGENT">Invoice Per Agent</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={onIssueInvoice}
                                disabled={state.isInvoiceInProgress || state.loading}
                                startIcon={state.isInvoiceInProgress ? <CircularProgress size={16} color="inherit" /> : null}
                                sx={{ textTransform: 'none' }}
                            >
                                {state.isInvoiceInProgress ? 'Invoicing In Progress...' : 'Issue Invoice'}
                            </Button>
                        </Grid>
                    </>
                )}
                <Grid item>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={onRefresh}
                        disabled={state.loading}
                        startIcon={state.loading ? <CircularProgress size={16} color="inherit" /> : null}
                        sx={{ textTransform: 'none' }}
                    >
                        Refresh
                    </Button>
                </Grid>
            </Grid>
            {state.notification && (
                <Alert severity={state.notification.isSuccess ? 'success' : 'error'} sx={{ mt: 1, mb: 1 }}>
                    {state.notification.message}
                </Alert>
            )}
        </div>
    );
}
